<template>
  <div class="loader_container" id="peelhuntLoader">
    <div id="cover" class="ng-star-inserted"></div>
    <div class="IFloader ng-star-inserted">
      <span> </span>
    </div>
    <span class="IFloaderText" v-html="title"></span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
  mounted() {
    // var elem = document.getElementById("peelhuntLoader");
    // console.log("elem--->>", elem);
    // setTimeout(() => {
    //   if (elem.requestFullscreen) {
    //     elem.requestFullscreen();
    //   } else if (elem.webkitRequestFullscreen) {
    //     /* Safari */
    //     elem.webkitRequestFullscreen();
    //   } else if (elem.msRequestFullscreen) {
    //     /* IE11 */
    //     elem.msRequestFullscreen();
    //   }
    // }, 10);
  },
};
</script>

<style>
#cover {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 1100;
  width: 100%;
  height: 100%;
}

#cover + .IFloader {
  width: 10px;
  height: 10px;
  top: 50%;
  animation: spin 2s linear infinite;
  margin: 0 auto;
  z-index: 5000;
  position: fixed;
  left: 50%;
}
.IFloaderText {
  text-align: center;
  font-weight: bold;
  top: 50%;
  margin: 0 auto;
  z-index: 5000;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 100px;
}

#cover + .IFloader.ng-star-inserted:before,
#cover + .IFloader:before {
  background: #37133d;
  background: #37133d;
}

#cover + .IFloader.ng-star-inserted:before,
#cover + .IFloader:before {
  width: 20px;
  height: 20px;
  background: #37133d;
  content: "";
  transform: rotate(45deg);
  position: absolute;
  top: 50%;
  margin-top: -10px;
  left: 24%;
}

#cover + .IFloader span {
  background: #efdbb2;
  width: 10px;
  height: 10px;
  position: absolute;
  z-index: 1;
  transform: rotate(45deg);
}

#cover + .IFloader span {
  background: #efdbb2;
  background: #efdbb2;
}

#cover + .IFloader.ng-star-inserted:after,
#cover + .IFloader:after {
  background: #efdbb2;
  background: #efdbb2;
}

#cover + .IFloader.ng-star-inserted:after,
#cover + .IFloader:after {
  width: 20px;
  height: 20px;
  background: #efdbb2;
  content: "";
  transform: rotate(45deg);
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 11%;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
